import * as React from 'react';

const Tooltip = ({ text, position = 'top', children }) => (
  <span className={`tooltip is-tooltip-${position}`} data-tooltip={text}>
    {children}
  </span>
);

export default Tooltip;
